type FeatureFlag = {
  value: string;
  description: string;
};

/**
 * IMPORTANT, When adding a new feature flag, please add team, name, and description.
 *
 * Teams are ENG, SUPPORT, PRODUCT
 */
export const featureFlags: FeatureFlag[] = [
  {
    value: "carousel-debug",
    description:
      "(SUPPORT) Adds debugging tools for troubleshooting carousel components.",
  },
  {
    value: "prevent-theme-header-footer",
    description:
      "(SUPPORT) Prevents theme-defined headers and footers from being automatically applied.",
  },
  {
    value: "debug-insights",
    description:
      "(ENG/PRODUCT, Max) Debugging tool to view all the insights returned from our AI.",
  },
  {
    value: "archived-pages",
    description:
      "(SUPPORT) Enables support for managing and restoring archived pages.",
  },

  {
    value: "component-previews",
    description:
      "(ENG, Gabe) Renders component JSON outside the canvas instead of screenshots.",
  },
  {
    value: "write-through-products-sync",
    description:
      "(ENG, Noah) When loading products, we request them from the storefront API if possible and write them through to the database.",
  },
  {
    value: "products-shops-menu-item",
    description:
      "(ENG, Kevin) Controls visibility of the Products page in Shops.",
  },
  {
    value: "use-online-page-generation",
    description:
      "(ENG, Max) Enables online page generation instead of running page gen offline on trigger.",
  },
  {
    value: "user-activation-tutorial",
    description:
      "(ENG, Derek) Enables the user activation tutorial on the homepage.",
  },
  {
    value: "replo-agent-opus",
    description:
      "(ENG, Gabe) Uses Claude Opus 4.5 model for chat agent instead of Sonnet.",
  },
  {
    value: "replo-agent-local-opencode",
    description:
      "(ENG) Connects to a local opencode server instead of the Cloudflare agent.",
  },
  {
    value: "product-split-ui",
    description:
      "(ENG, Andrew) Separates shops into Shopify Theme Builder Projects and Replo Sites.",
  },
  {
    value: "integrations-v2-ui",
    description:
      "(ENG, Ryan) Enables the new top-level Integrations UI and hides the legacy Integrations entry in Settings.",
  },
];

export type FeatureName = FeatureFlag["value"] | `announcement_${string}`;
